<script setup>
import { cn } from "@/lib/utils";
import {
  DropdownMenuContent,
  DropdownMenuPortal,
  useForwardPropsEmits,
} from "reka-ui";
import { computed } from "vue";

const props = defineProps({});
// const emits = defineEmits([]);

const delegatedProps = computed(() => {
  // eslint-disable-next-line no-unused-vars
  const { class: _, ...delegated } = props;
  return delegated;
});

const forwarded = useForwardPropsEmits(delegatedProps /*emits*/);
</script>

<template>
  <DropdownMenuPortal>
    <DropdownMenuContent
      v-bind="{ ...forwarded, ...$attrs }"
      :class="
        cn(
          'vf-z-[9999] vf-min-w-32 vf-overflow-hidden vf-rounded-md vf-border vf-bg-popover vf-p-1 vf-text-popover-foreground vf-shadow-md',
          'data-[state=open]:vf-animate-in data-[state=closed]:vf-animate-out data-[state=closed]:vf-fade-out-0 data-[state=open]:vf-fade-in-0',
          'data-[state=closed]:vf-zoom-out-95 data-[state=open]:vf-zoom-in-95 data-[side=bottom]:vf-slide-in-from-top-2',
          'data-[side=left]:vf-slide-in-from-right-2 data-[side=right]:vf-slide-in-from-left-2 data-[side=top]:vf-slide-in-from-bottom-2',
          props.class
        )
      "
    >
      <slot />
    </DropdownMenuContent>
  </DropdownMenuPortal>
</template>
